import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountrySupportService {

  public userCountryRelatedData;

  private allCountryRelatedData = {
    '91': {
      'name': 'India',
      'language': 'en',
      'currency': {
        'name': 'Indian Rupee',
        'code': 'INR',
        'icon': 'assets/themes/icons/docquity-reward-coin-peso.svg'
      }
    },
    '62': {
      'name': 'Indonesia',
      'language': 'id',
      'currency': {
        'name': 'Indonesian Rupiah',
        'code': 'IDR',
        'icon': 'assets/themes/icons/docquity-reward-coin-rupiah-id.svg'
      }
    },
    '63': {
      'name': 'Philippines',
      'language': 'id',
      'currency': {
        'name': 'Philippine Peso',
        'code': 'PHP',
        'icon': 'assets/themes/icons/docquity-reward-coin-peso.svg'
      }
    },
    '52': {
      'name': 'Mexico',
      'language': 'es',
      'currency': {
        'name': '',
        'code': '',
        'icon': ''
      }
    }
  }
  /**
   *enable redeem for countries
   */
  public enableRedeemCountries = environment.enableRedeemSurveyForCountryCodes;
  /**
   *user country code
   */
  private userCountryCode !: string;

  constructor() {
    const userCountryCode = localStorage.getItem('country_code') as string;
    this.userCountryCode = userCountryCode;
    this.setUserCountrySupportData(userCountryCode);
  }

  /**
   * get the user country supported data
   * used mainly to get the country wise currency
   * phase 1 for ph and id
   */
  private setUserCountrySupportData(countryCode: string): void {
    this.userCountryRelatedData = this.allCountryRelatedData[countryCode] ?? this.allCountryRelatedData['91'];
  }

  /**
   * should enable survey having redeem points
   */
  public shouldEnableSurveyRedeem(): boolean{
    return this.enableRedeemCountries.includes(this.userCountryCode) || this.enableRedeemCountries.includes('+'+this.userCountryCode);
  }
}
